module.exports = __webpack_public_path__ + "img/tarieven.067f6043.jpg";